import React, { useState, useEffect, useMemo } from 'react'
import { useTable, useSortBy, useGlobalFilter, useFilters, usePagination } from 'react-table'
import { Button, Badge, Modal, ModalHeader, ModalBody, ModalFooter, Input, InputGroup, InputGroupAddon, Jumbotron } from 'reactstrap';
import TestImg from './../../../assets/UPS-Van-Back-icon.png'
import Timer from 'react-compound-timer'

import { COLUMNS } from './columnForPhoneList'
import { GlobalFilter } from './../../Shipment/GlobalFilter'

import './../../Shipment/table.css'
import './purchasePhoneCallStyle.css'
export default function PurchasePhoneCall() {
    const columns = useMemo(() => COLUMNS, [])
    const [data2, setData2] = useState([]);

    const data = useMemo(() => data2, [data2])


    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        //rows,
        page,
        nextPage,
        previousPage,
        canNextPage,
        canPreviousPage,
        pageOptions,
        gotoPage,
        pageCount,
        setPageSize,
        prepareRow,
        state,
        setGlobalFilter,

    } = useTable({
        columns,
        data,
        initialState: {
            hiddenColumns: [
                "Watch info2",
                //"Preis2"
            ]
        },
        autoResetSortBy: false,
        autoResetPage: false,
        autoResetFilters: false,
        autoResetGlobalFilter: false,
        autoResetSelectedRows: false,
        autoResetRowState: false
    },
        useFilters,
        useGlobalFilter,
        useSortBy,
        usePagination,
    )

    const { globalFilter, pageIndex, pageSize } = state
    const getPhoneNegotiation = async () => {
        try {
            const response = await fetch(
                "/purchasing/phoneNegotiations",
                {
                    method: "get",
                    headers: new Headers({
                        "Content-Type": "application/json",
                    }),
                }
            );
            const payload = await response.json();
            //setApiData(payload);
            setData2(payload)
            console.log(payload)
            console.log(payload.length)
            //console.log(payload)
            if (!response.ok) {
                const payload = await response.text();
                alert(payload);
            }
        } catch (e) {
            console.log(e);
        }
    };


    const [toggleReCallList, setToggleReCallList] = useState(false)
    //modal belongies
    const [show, setShow] = useState(false);
    const [modalData, setModalData] = useState('');
    const [canSendOffer, setCanSendOffer] = useState(false);
    const [agreedPrice, setAgreedPrice] = useState('');
    const [comment, setComment] = useState('');
    const [totalDuration, setTotalDuration] = useState(0);
    //Nested modal 
    const [nestedModal, setNestedModal] = useState(false);
    const [ImageSrc, setImageSrc] = useState();
    const BoxtoggleNested = (imgSrc) => {
        setNestedModal(!nestedModal);
        setImageSrc(imgSrc);
    };
    const [zoomIn, setZoomIn] = useState(false);

    // call status recorder
    const [callIsActive, setCallActive] = useState(false);
    const [callStartTime, setCallStart] = useState(null);
    const [lastCallTime, setLastCallTime] = useState(null);
    const [callsCount, setCallsCount] = useState(0);

    const handleCallStatusToggle = async () => {
        if (!callIsActive) {
            // start call and store timestamp
            setCallActive(true);
            setCallStart(new Date());
        } else {
            // end call and calculate call duration and send to API
            const now = new Date();
            const callDurationSeconds = Math.floor((now.getTime() - callStartTime.getTime()) / 1000);
            setCallActive(false);
            setCallStart(null);
            if (callDurationSeconds > 5) {
                console.log('call length (s): ' + callDurationSeconds);
                try {
                    const response = await fetch(
                        `/purchasing/phoneNegotiations/logCall/${modalData.row.original.offerId}`,
                        {
                            method: "POST", headers: new Headers({ "Content-Type": "application/json", }),
                            body: JSON.stringify({ duration: callDurationSeconds }),
                        }
                    );
                    if (response.ok) {
                        setLastCallTime(new Date());
                        setCallsCount(callsCount + 1);
                        setToggleReCallList(!toggleReCallList)
                        console.log(response)

                        let x = ((callDurationSeconds) / 60)
                        console.log(x)
                        setTotalDuration(Math.round(totalDuration + x))
                    }
                    if (!response.ok) {
                        const payload = await response.text();
                        alert(payload);
                    }
                } catch (e) {
                    console.log(e);
                    alert('Could not write call history')
                }

            }
        }
    };




    const handleClose = () => {
        setShow(false);
        // end call if active
        if (callIsActive) { handleCallStatusToggle(); }
        // reset modal
        setComment('');
        setAgreedPrice('');
    };

    const handleShow = (cell) => {


        // get offer object from clicked cell
        const clickedOffer = cell.row.original;
        console.log(clickedOffer);

        let x = ((clickedOffer.callHistory.reduce((a, v) => a = a + v.durationSeconds, 0)) / 60)
        setTotalDuration(Math.round(x))

        // intialize modal
        setCallActive(false);
        if (clickedOffer.callHistory.length > 0) {
            const lastCallTimestamp = clickedOffer.callHistory[clickedOffer.callHistory.length - 1].time;
            const lastCallTime = new Date(lastCallTimestamp);
            setLastCallTime(lastCallTime);
        } else {
            setLastCallTime(null);
        }
        setCallsCount(clickedOffer.callHistory.length);
        setAgreedPrice(clickedOffer.agreedPrice);
        if (clickedOffer.agreedPrice) {
            setCanSendOffer(true);
        }
        setComment(clickedOffer.comments);
        setModalData(cell);

        setShow(true);
        console.log(modalData)
    }

    const handleSaveBtn = async (offerID) => {
        try {
            const response = await fetch(
                `/purchasing/phoneNegotiations/${offerID}`,
                {
                    method: "POST",
                    headers: new Headers({
                        "Content-Type": "application/json",
                    }),
                    body: JSON.stringify({
                        newComment: comment,
                        agreedPrice: agreedPrice,
                    }),
                }
            );
            //const payload = await response.json();
            //console.log('this is console for post:', payload, response)
            //console.log(payload)
            if (response.ok) {
                //handleClose()
                setToggleReCallList(!toggleReCallList);
                setCanSendOffer(Boolean(agreedPrice));
            }
            if (!response.ok) {
                const payload = await response.text();
                alert(payload);
            }
            return true;
        } catch (e) {
            console.log(e);
            alert('Could not save');
            return false;
        }
    }
    const handleDeletBtn = async (offerID, rejectionReason) => {
        try {
            const response = await fetch(
                `/purchasing/phoneNegotiations/reject/${offerID}`,
                {
                    method: "POST",
                    headers: new Headers({
                        "Content-Type": "application/json",
                    }),
                    body: JSON.stringify({ rejectionReason: rejectionReason })
                }
            );
            //const payload = await response.json();
            //console.log('this is console for post:', payload, response)
            //console.log(payload)
            if (response.ok) {
                handleClose()
                setToggleReCallList(!toggleReCallList)
            }
            if (!response.ok) {
                const payload = await response.text();
                alert(payload);
            }
        } catch (e) {
            console.log(e);
            alert('Could not delete')
        }
    }
    const handleSendBtn = async (offerID) => {
        try {

            // try to save before sending - if saving fails, abort
            const saveSuccessful = await handleSaveBtn(offerID);
            if (!saveSuccessful)
                return;

            const response = await fetch(
                `/purchasing/phoneNegotiations/sendOffer/${offerID}`,
                {
                    method: "POST",
                }
            );
            //const payload = await response.json();
            //console.log('this is console for post:', payload, response)
            //console.log(payload)
            if (response.ok) {
                handleClose()
                setToggleReCallList(!toggleReCallList)
            }
            if (!response.ok) {
                const payload = await response.text();
                alert(payload);
            }
        } catch (e) {
            console.log(e);
            alert('Could not send')
        }
    }
    useEffect(() => {
        getPhoneNegotiation();
    }, [toggleReCallList])

    useEffect(() => { document.title = "Einkaufsgespräche"; }, []);

    return (

        <div className='shippingTable'>
            <div className='shippingListHeader'>
                <Badge><h3>Einkaufsgespräche Telefonliste</h3></Badge>
                <GlobalFilter filter={globalFilter} setFilter={setGlobalFilter} />
                <select className="form-control" style={{ width: 'unset' }} value={pageSize} onChange={e => setPageSize(Number(e.target.value))}>
                    {
                        [10, 15, 20, 30, 50, 'All'].map((pageSize) => (
                            <option key={pageSize} value={pageSize === 'All' ? 10000 : pageSize}>
                                Show {pageSize}
                            </option>
                        ))
                    }
                </select>
            </div>


            <table {...getTableProps()}>
                <thead>
                    {headerGroups.map(headerGroup => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column, index) => (
                                <th key={index}>
                                    <div className='d-block border-0' {...column.getHeaderProps(column.getSortByToggleProps())}>
                                        {column.render('Header')}
                                        <span style={column.Header === 'Uhr Info' || column.Header === 'Preis' ? { display: 'none' } : {}}>
                                            {column.isSorted
                                                ? column.isSortedDesc
                                                    ? ' 🔽'
                                                    : ' 🔼'
                                                : ' ▶️'}
                                        </span>
                                    </div>

                                </th>
                            )
                            )
                            }
                        </tr>
                    )
                    )
                    }
                </thead>
                <tbody {...getTableBodyProps()}>
                    {page.map(row => {
                        prepareRow(row)
                        // console.log(row)
                        return (
                            <tr style={row.original.agreedPrice ? { cursor: 'pointer', backgroundColor: '#ddffdd' } : { cursor: 'pointer' }} {...row.getRowProps()}>
                                {row.cells.map(cell => {
                                    return <td {...cell.getCellProps()} style={cell.column.Header === "Telephone" ? { whiteSpace: "nowrap" } : {}}
                                        onClick={() => { handleShow(cell) }}
                                    >
                                        {cell.render('Cell')}
                                    </td>
                                })}
                            </tr>
                        )
                    })}
                </tbody>
            </table>
            <div className='pageOptions' style={{ marginLeft: 'auto', marginRight: 'auto', display: 'table' }}>
                <Button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
                    {'<<'}
                </Button>
                <Button onClick={() => previousPage()} disabled={!canPreviousPage}>Vorherige Seite</Button>
                <span>
                    Page{' '}
                    <strong>
                        {pageIndex + 1} of {pageOptions.length}
                    </strong>{' '}
                </span>
                <Button onClick={() => nextPage()} disabled={!canNextPage}>Nächste Seite</Button>
                <Button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
                    {'>>'}
                </Button>
            </div>
            <Modal
                style={{ minWidth: '770px' }}
                centered={true}
                isOpen={show}
                toggle={handleClose}
                backdrop="static"
            >{console.log(modalData)}
                <ModalHeader toggle={handleClose}>
                    <span title={modalData ? modalData.row.original.manufacturePeriod ? 'HZ=Herstellungszeitraum' : '' : ''}>
                        {modalData ? `${modalData.row.original.brand}  ${modalData.row.original.model} ${modalData.row.original.reference} 
                     ${modalData.row.original.manufacturePeriod ? ' | HZ: ' + modalData.row.original.manufacturePeriod : ''}
                     ` : ''}
                     </span>
                    <br />
                    <span title='GM=Gehäusematerial. BM=Bandmaterial.' style={{ fontSize: 'large', color: '#4caf50' }}>
                        {modalData ? `${modalData.row.original.hasBox ? 'mit Box' : ''}  ${modalData.row.original.hasPapers ? 'mit Papieren' : ''} ${modalData.row.original.caseMaterial ? ' | GM: ' + modalData.row.original.caseMaterial : ''} ${modalData.row.original.braceletMaterial ? ' | BM: ' + modalData.row.original.braceletMaterial : ''} ${modalData.row.original.dialColor ? ' | DC: ' + modalData.row.original.dialColor : ''}` : ''}
                    </span>
                </ModalHeader>
                <ModalBody>

                    <div className='d-flex justify-content-md-between align-items-center'>
                        {callIsActive
                            ? <button className="btn btn-sm btn-danger" onClick={handleCallStatusToggle}>&#9990; Ende protokollieren</button>
                            : <button className="btn btn-sm btn-primary" onClick={handleCallStatusToggle}>&#9990; Start protokollieren</button>
                        }
                        {callIsActive
                            ?
                            <>
                                <span className="mx-4 badge badge-pill badge-danger p-2" style={{ fontSize: '1rem', fontWeight: '700' }}>Anruf läuft: {' '}
                                    <Timer>
                                        <Timer.Minutes className='p-2' /> min {`${' '}`}
                                        <Timer.Seconds /> sek
                                    </Timer>
                                </span>
                            </>
                            : <span className="mx-4 badge badge-pill badge-light" style={{ fontSize: '1rem', fontWeight: '700' }}>
                                {callsCount} x angerufen
                                {lastCallTime ? <>
                                    , Letzter Anruf: {lastCallTime.toLocaleString()}
                                    , Gesamt: {totalDuration} min
                                </> : null}
                            </span>
                        }
                    </div>
                    <hr />

                    <div className='d-flex justify-content-between'>
                        <ul className='pl-0' style={{ listStyle: 'none' }}>
                            <li>{modalData ? `${modalData.row.original.sellerName ? modalData.row.original.sellerName : 'Name nicht bekannt'}` : ''}</li>
                            <hr style={{ margin: '3px' }} />
                            <li>{modalData ? `${modalData.row.original.sellerPhone ? modalData.row.original.sellerPhone : 'Keine Telefonnummer'}` : ''}</li>
                            <hr style={{ margin: '3px' }} />
                            <li>{modalData ? `${modalData.row.original.sellerEmail ? modalData.row.original.sellerEmail : 'Keine Email-Adresse'}` : ''}</li>
                            <hr style={{ margin: '3px' }} />
                            <li>{modalData ? `${modalData.row.original.sellerCountry ? modalData.row.original.sellerCountry : 'Land unbekannt'}` : ''}</li>
                        </ul>
                        <ul className='' style={{ listStyle: 'none', border: '3px solid #4caf50', padding: '10px' }}>
                            <li>{modalData ? `Verkäuferwunsch: ${modalData.row.original.initialSellerPrice ? (modalData.row.original.initialSellerPrice + ' EUR') : 'keine Angabe'}` : ''}</li>
                            <hr style={{ margin: '3px' }} />
                            <li>{modalData ? `Unser min. Preis: ${modalData.row.original.minimumOfferPrice ? (modalData.row.original.minimumOfferPrice + ' EUR') : 'keine Angabe'}` : ''}</li>
                            <li style={{ color: '#dc3545', fontWeight: 'bolder' }}>{modalData ? `Unser max. Preis: ${modalData.row.original.maximumOfferPrice + ' EUR'}` : ''}</li>
                        </ul>
                    </div>
                    <Jumbotron className='p-4 mb-3'>
                        <h6>Kommentar des Verkäufers:</h6>
                        <p className="">{modalData ? modalData.row.original.sellerComment ? modalData.row.original.sellerComment : 'kein Wert' : 'kein Wert'}</p>
                    </Jumbotron>
                    <textarea className='w-100' style={{ minHeight: "150px" }}
                        onChange={(e) => {
                            setComment(e.target.value ? e.target.value : null)
                        }}
                        placeholder='Interner Kommentar. (Dieser Text wird nicht an den Verkäufer übermittelt!)'
                        value={comment ?? ""}
                    ></textarea>
                    <div className='imgContainer'>
                        {modalData.row &&
                            modalData.row.original.picUrls.map((pic, index) => {
                                return (
                                    <img key={index} src={pic} onClick={() => { BoxtoggleNested(pic) }} alt='watch' ></img>
                                )
                            })
                        }
                        <Modal
                            size="lg"
                            centered={true}
                            isOpen={nestedModal}
                            toggle={BoxtoggleNested}
                        >
                            <ModalHeader toggle={BoxtoggleNested}>Uhr Bild</ModalHeader>
                            <ModalBody className='ModalBody'>
                                <img src={ImageSrc} style={zoomIn ? { transform: "scale(2)" } : {}} alt='Watch' onClick={() => { setZoomIn(!zoomIn) }} />
                            </ModalBody>
                            <ModalFooter className='justify-content-between'>
                                <div className='imgContainer'>
                                    {modalData.row &&
                                        modalData.row.original.picUrls.map((pic, index) => {
                                            return (
                                                <img key={index} src={pic} onClick={() => { setImageSrc(pic) }} alt='watch' ></img>
                                            )
                                        })
                                    }
                                </div>
                                <Button color="secondary" onClick={BoxtoggleNested} style={{ marginLeft: 'auto' }}>
                                    Schließen
                                </Button>
                            </ModalFooter>
                        </Modal>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <div className="dropdown">
                        <button className="btn btn-outline-danger dropdown-toggle" type="button" data-toggle="dropdown">
                            Ablehnen
                        </button>
                        <div className="dropdown-menu">
                            <a className="dropdown-item" style={{ cursor: "pointer" }} onClick={() => { handleDeletBtn(modalData.row.original.offerId, "NotInterested") }}>Wir haben kein Interesse mehr</a>
                            <a className="dropdown-item" style={{ cursor: "pointer" }} onClick={() => { handleDeletBtn(modalData.row.original.offerId, "NoAgreement") }}>Keine Einigung mit Verkäufer mgl.</a>
                        </div>
                    </div>
                    <InputGroup style={{ display: 'contents' }}>
                        <InputGroupAddon addonType="prepend">Verhandelter Preis EUR:</InputGroupAddon>
                        <Input
                            onInput={(e) => {
                                setAgreedPrice(e.target.value ? e.target.value : null);
                            }}
                            defaultValue={modalData && modalData.row.original.agreedPrice ? modalData.row.original.agreedPrice : ''}
                        />
                    </InputGroup>
                    <Button color="success" onClick={() => { handleSaveBtn(modalData.row.original.offerId); }}>Speichern</Button>{' '}
                    <Button color="primary" onClick={() => { handleSendBtn(modalData.row.original.offerId); }}>Absenden</Button>
                </ModalFooter>
            </Modal>
        </div>
    )
}

